import { render, staticRenderFns } from "./ActivityRead.vue?vue&type=template&id=7f48fda2&scoped=true&"
import script from "./ActivityRead.vue?vue&type=script&lang=js&"
export * from "./ActivityRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48fda2",
  null
  
)

export default component.exports